/**
 * Client-side mirror of supabase/functions/_shared/investor-parsing.ts.
 *
 * Kept in sync with the edge-function implementation: any change to parsing
 * rules must be applied here AND in the shared edge file AND in the SQL
 * function `public.resolve_active_lock_investor`.
 */

export function parseInvestorFromLoanProgram(loanProgram: string | null | undefined): string | null {
  if (!loanProgram) {
return null;
}

  for (const kw of [' - Correspondent', ' - Wholesale', ' - Non-Delegated']) {
    const idx = loanProgram.indexOf(kw);
    if (idx > 0) {
return loanProgram.substring(0, idx).trim() || null;
}
  }

  const parenIdx = loanProgram.indexOf('(');
  if (parenIdx > 0) {
    const before = loanProgram.substring(0, parenIdx).trim();
    if (before && /[a-zA-Z]/.test(before)) {
return before;
}
  }

  const dashIdx = loanProgram.search(/\s+-\s+/);
  if (dashIdx > 0) {
    const candidate = loanProgram.slice(0, dashIdx).trim();
    if (/[a-z]/i.test(candidate) && /(?:,\s+|\s+)(?:LLC|L\.L\.C\.|Inc\.?|Corp\.?|Corporation|L\.P\.?|LP|LLP)$/i.test(candidate)) {
      return candidate;
    }
  }

  return null;
}

/**
 * Program-first investor resolution for active-lock and lock-version material
 * identity contexts.
 *
 * When a delivery lock has been captured, `rate_lock_loan_program` is the
 * authoritative source. `investor_name` may be stale. Prefer the parsed
 * program; fall back to investor_name only when the program is not
 * parseable.
 */
export function resolveActiveLockInvestor(
  loanProgram: string | null | undefined,
  investorName: string | null | undefined
): string | null {
  const parsed = parseInvestorFromLoanProgram(loanProgram);
  if (parsed) {
return parsed;
}
  const fallback = (investorName ?? '').trim();
  return fallback || null;
}
